import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import common from './modules/common'
import backtolist from "./modules/backtolist"

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    common,
    backtolist
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js